const questions = [
  {
    questionText: "1. Mikä seuraavista tuntuu sopivimmalta käteesi?",
    answerOptions: [
      { answerText: "Sideharso", value: "a" },
      { answerText: "Kynä", value: "b" },
      { answerText: "Kirja", value: "c" },
      { answerText: "Kartta", value: "d" },
      { answerText: "Kirves", value: "e" },
    ],
  },
  {
    questionText: "2. Ystäväsi loukkaa metsäretkellä jalkansa. Miten toimit? ",
    answerOptions: [
      { answerText: "Annan välittömästi ensiavun", value: "a" },
      { answerText: "Rauhoittelen ja lohdutan ystävää", value: "b" },
      {
        answerText: "Selvitän sijaintimme ja miten tulee toimia",
        value: "c",
      },
      { answerText: "Teen oksista lastan jalkaan", value: "d" },
      { answerText: "Kannan kaverin palomiesotteella autolle", value: "e" },
    ],
  },
  {
    questionText: "3. Mitä katsot mieluiten tv:stä?",
    answerOptions: [
      { answerText: "Ohjelmaa tosielämän ystävistä", value: "a" },
      { answerText: "Elokuvaa toivottomasta rakkaudesta", value: "b" },
      {
        answerText: "Henkilökuvaa väärinymmärretystä taiteilijasta",
        value: "c",
      },
      { answerText: "Dokumenttia shakkinerosta", value: "d" },
      {
        answerText:
          "Toimintasarjaa mutaation seurauksena syntyneestä supersankarista",
        value: "e",
      },
    ],
  },
  {
    questionText: "4. Millaista liikuntaa harrastat mieluiten?",
    answerOptions: [
      { answerText: "Kävelylenkki ystävän seurassa", value: "a" },
      { answerText: "Liikunta on pois luomistyöltä ", value: "b" },
      {
        answerText: "Joogaa ja mindfulnessia",
        value: "c",
      },
      { answerText: "Suunnistusta tai polkujuoksua", value: "d" },
      {
        answerText: "Painia tai painonnostoa. Kaikki muu on peliä tai leikkiä.",
        value: "e",
      },
    ],
  },
  {
    questionText: "5. Millaista musiikkia kuuntelet?",
    answerOptions: [
      { answerText: "Kotimaista iskelmää", value: "a" },
      {
        answerText: "Väkevää ja riipaisevaa musiikkia, jossa on tunnetta",
        value: "b",
      },
      {
        answerText: "Instrumentaalimusiikkia, joka auttaa keskittymään",
        value: "c",
      },
      { answerText: "Korkeatempoista poppia tai EDM:ä", value: "d" },
      { answerText: "Mitä raskaampaa, sen parempi", value: "e" },
    ],
  },
]

export default questions
